import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';

import { BasicInputTypeEnum, EntityTypeEnum, ModalParentIdEnum, ModalType } from '../../../shared/enums';
import { IStudent, IUser } from '../../../shared/interfaces';
import { environment } from './../../../environments/environment';
import { SupportBetaComponent } from '../support-beta/support-beta.component';
import { ModalService } from '../../../shared/services';
import { ErrorBisModalComponent } from '../error-bis-modal/error-modal.component';

@Component({
    selector: 'app-select-user-modal',
    templateUrl: './select-user-modal.component.html',
    styleUrls: ['./select-user-modal.component.scss'],
})
export class SelectUserModalComponent implements OnInit {
    @Input()
    public currentUser: IUser;

    @Input()
    public user: IUser;

    @Input()
    public students: IStudent[];

    @Input()
    public url: string;

    @Output()
    public goToRouteEmitter = new EventEmitter<{ route: string; param: any }>();

    @Output()
    public openCalendarEmitter = new EventEmitter<IUser>();

    @Output()
    public selectUserEmitter = new EventEmitter<IUser>();

    public userType = EntityTypeEnum;

    public research: FormGroup;
    public basicInputTypeEnum = BasicInputTypeEnum;

    public showQrCode = false;
    public qrCodePath: string;

    public baseUrl = environment.base;
    public userId: number;

    constructor(private fb: FormBuilder,
                private modalService: ModalService,) {}

    ngOnInit(): void {
        this.research = this.fb.group({
            search: [''],
        });
    }

    public selectCurrentUser(user: IUser): void {
        this.showQrCode = false;
        this.research.reset();
        this.selectUserEmitter.emit(user);

        if (user?.type === 'student' && !user?.parentsIds?.length) {
            this.modalService.openModalWithComponent({
                type: ModalType.STANDARD,
                body: {
                    title: 'HOME.MODAL.WARNING.TITLE',
                },
                component: {
                    componentRef: ErrorBisModalComponent,
                    parentIdRef: ModalParentIdEnum.BODY_CONTENT,
                    config: {
                        inputs: {
                            error: 'ERROR.STUDENT.NO_PARENTS',
                        },
                    },
                },
            });
        }
    }

    public toggleQrCode(userId: number, codePath: string): void {
        if (!this.userId || userId === this.userId) {
            this.showQrCode = !this.showQrCode;
        } else if (userId !== this.userId && !this.showQrCode) {
            this.showQrCode = !this.showQrCode;
        }
        this.qrCodePath = codePath;
        this.userId = userId;
    }

    public goToRoute(route: string, param: any): void {
        this.goToRouteEmitter.emit({ route, param });
    }

    public openCalendarModal(student: IUser): void {
        this.openCalendarEmitter.emit(student);
    }

    public get searchText(): string {
        return this.research.controls.search.value;
    }
}
